import angular from 'angular';

angular.module('cloudX').factory('typeConversionSvc', function() {
  // field.value = new Date(field.value)
  function fromDb(listOfFields) {
    angular.forEach(listOfFields, function(field) {
      if (field.value) {
        switch (field.type) {
          //case 0: // boolean
          //    if (field.value === null | field.value === undefined) break;
          //    field.value = (field.value ? 1 : 0); break;
          case 3: // date
            if (field.value) field.value = new Date(field.value);
            break;
          case 4: // time
          // No conversion for now. Time = string
          // if (field.value) field.value = new Date(field.value);
          case 14: // linkList
            for (var t = 0; t < field.value.length; t++) {
              if (field.value[t].fields) {
                for (var t2 = 0; t2 < field.value[t].fields.length; t2++) {
                  if (field.value[t].fields[t2].type === 3) {
                    field.value[t].fields[t2].value = new Date(field.value[t].fields[t2].value);
                  }
                }
              }
            }
            break;
          default:
            break;
        }
      }
    });
    return listOfFields;
  }

  /*  Boolean = 0,
      Integer = 1,
      Decimal = 2,
      Date = 3,
      Time = 4,
      StringShort = 5,
      StringMedium = 6,
      StringLong = 7,
      Text = 8,
      Address = 9,
      Currency = 10,
      LegalForm = 11,
      Addresses = 12,
      Communication = 13,
      Links = 14,
      Language = 15
  */

  // field.value = field.value.toISOString();
  // + field is put in an array (for sending to backend)
  function toDb(field) {
    var fieldToSave = field;
    if (field.value) {
      switch (field.type) {
        case 3: // date
          // We need to make a copy of the field, because if we don't the value that is displayed is also changed
          fieldToSave = angular.copy(field);
          if (fieldToSave.value instanceof Date)
            fieldToSave.value = fieldToSave.value.toISOString();
          break;
        case 4: // date (time)
        // No conversion for now. Time = string
        //fieldToSave = angular.copy(field);
        //if (fieldToSave.value instanceof Date) fieldToSave.value = fieldToSave.value.toISOString();
        //break;
        case 14: // linkList
          for (var t = 0; t < field.value.length; t++) {
            if (field.value[t].fields) {
              for (var t2 = 0; t2 < field.value[t].fields.length; t2++) {
                if (field.value[t].fields[t2].type === 3) {
                  field.value[t].fields[t2].value = field.value[t].fields[t2].value.toISOString();
                }
              }
            }
          }
          break;
        default:
          break;
      }
    }
    return fieldToSave;
  }

  return {
    fromDb: fromDb,
    toDb: toDb,
  };
});
